import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ServicesPage from "@/pages/services/page";
import CaseStudyPage from "@/pages/case-study/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";
import PrivacyPage from "@/pages/privacy/page";
import TermsPage from "@/pages/terms/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/case-study", element: <CaseStudyPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/privacy", element: <PrivacyPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
